import { axiosAPI } from '@/plugins/axios';

export const loadTeamSetting = () => axiosAPI.get('/team-setting');
export const updateTeamSettingItem = (itemType: string, itemId: string) => (
  axiosAPI.put(`/team-setting/${itemType}/${itemId}`)
);
